<template>
  <div class="task-list-item">
    <div
      :class="{
        /* TODO: BEM */
        'task': true,
        'file-drop-zone': active_drop_target,
        'file-uploading': attachment_uploading,
        'is-deleted': task.deleted,
        'has-jobstopper': task.jobstopper,
        'timer-active': active_task_timer,
        'finish-today': finish_today,
        'task--is-url': taskIsUrl,
      }"
      v-if="task.$ready"
      :style="task_style"
      @drop.prevent.stop="onDropAttachment"
      @dragover="onDragOver"
      @dragleave="onDragLeave"
      @click.self="onClickTask"
      @dblclick="onClickTask /* Detect rage click */"
    >
    <!--sortidx: {{ task.sortidx }}-->
      <!-- @mouseover="onMouseOver" -->
      <!-- @mouseleave="onMouseLeave"  -->
      <!-- v-tooltip="{ content: 'Double click to open task', delay: { show: 1000, hide: 50 }, offset: 2 }" -->
      <div style="display: flex; flex-direction: column;">
        <!--sessionId: {{ sessionId }}<br/>
        task.sessionId: {{ task.sessionId }}<br/>-->

        <!-- TODO: Move to component  -->
        <div v-if="!attachment_mime[ attachment_id_preview ]">
          <div v-if="attachment_id_preview !== false" style="height: 48px">
            <!-- Loading... -->
          </div>
        </div>
        <div v-else class="task-image mb-1" @click.self="onClickTask">
          <img
            v-if="attachment_mime[ attachment_id_preview ].preview"
            :src="task.attachments[ attachment_id_preview ]"
            @click="toggle_fullscreen = true" />
          <div v-else class="my-2 d-flex" @click.self="onClickTask">
            <font-awesome-icon
              :icon="[ 'far', attachment_mime[ attachment_id_preview ].icon ]"
              size="2x"
              style="margin: 1px" />
            <font-awesome-icon
              class="attachment-icon"
              v-if="attachment_mime[ attachment_id_preview ].supported"
              icon="eye"
              @click="toggle_fullscreen = true" />
            <a :href="task.attachments[ attachment_id_preview ]" target="_blank">
              <font-awesome-icon class="attachment-icon" icon="external-link-alt" />
            </a>
            <!--
            INFO: Does not work, when Content-Disposition in header is set
            <a :href="task.attachments[ attachment_id_preview ]" target="_blank" download>
              <font-awesome-icon class="attachment-icon" icon="download" />
            </a>
            -->
          </div>
          <portal to="modal-target-goal-details" v-if="toggle_fullscreen">
            <div
              class="overlay"
              style="display: block; z-index: 21"
              @click="toggle_fullscreen = false" />
            <img
              v-if="attachment_mime[ attachment_id_preview ].preview"
              class="image-zoom"
              :src="task.attachments[ Object.keys( task.attachments ).pop() ]"
              @click="toggle_fullscreen = false">
            <object
              class="object-zoom"
              v-else-if="attachment_mime[ attachment_id_preview ].supported"
              :type="attachment_mime[ attachment_id_preview ].type"
              :data="task.attachments[ attachment_id_preview ]" />
          </portal>
        </div>
        <div class="task__content" @click.self="onClickTask">
          <!-- TODO: Show first attachment here! -->
          <div class="task__checkbox">
            <!-- v-tooltip="{ content: 'Mark as unfinished' }" -->
            <!-- v-tooltip="{ content: 'Mark as finished' }"  -->
            <font-awesome-icon
              v-if="task.done"
              size="lg"
              :icon="['fas', 'check-circle']"
              style="color: #34a936;"
              @click="onCheckTask(false)"
            />
            <font-awesome-icon
              v-else
              size="lg"
              :icon="['far', 'square']"
              style="color: #687a8c;"
              @click="onCheckTask(true)"
            />
          </div>
          <div v-if="task.label" class="task__label" :style="{ 'background-color': task.label }"></div>
          <div style="width: 100%;" @click.self="onClickTask">
            <div class="task-list-item__title" @click.self="onClickTask">
              <span v-if="htmlTitle" class="search-result">
                <span v-html="htmlTitle" style="margin-right: 1em"/>
              </span>
              <template v-if="editTitleActive">
                <inline-editable-text
                  ref="name_title"
                  @change="onSetTaskName($event)"
                  @enter-edit-mode="onEnterEditMode"
                  :value="task.name"
                  :id="goalId"
                  :inline="false"
                  :lostFocusIsUpdate="true"
                  :resetOnCancel="false"
                  :tooltip="null"
                  :hideButtons="false"
                  :forceBlur="true"
                  @blur="onTitleLostFocus"
                  @lost-focus="onTitleLostFocus"
                  @cancel="onTitleLostFocus">
                  <div slot-scope="props" class="task-lane-item-text">
                    <span :class="[task.done ? 'line-through' : '']">{{props.text}}</span>
                  </div>
                </inline-editable-text>
              </template>
              <div v-else class="task-lane-item-text" @click.self="onClickTask">
              <!-- <div v-if="!editTitleActive" class="task-lane-item-text" @click.self="onClickTask"> -->
                <span
                  class="task-lane-item--time"
                  v-if="timeInSessionFrom && !task.done"
                  style="font-weight: bold"
                >{{ timeInSessionFrom * 1000 | shortTime }} -</span>
                {{ task.name }}
                <!-- v-tooltip="{ content: 'Edit item'}" -->
                <font-awesome-icon
                  class="inline-icon task-list-item__edit-button"
                  :icon="['fas', 'pen']"
                  @click.stop.prevent="onFocusRenameTask()"
                />
              </div>
            </div>
            <div v-if="!task.done" class="task-list-item-infos" @click.self="onClickTask">
              <div class="task-list-item-duration">
                <font-awesome-icon
                  v-if="false /* Disable for now */"
                  :icon="['far', !active_task_timer ? 'play-circle' : 'stop-circle']"
                  style="margin-right: 0.3em; color: #687a8c;"
                  size="lg"
                  @click.prevent="!active_task_timer ? onStartTimer(task.durationRemaining) : onStopTimer()"
                />

                <!-- TODO: This renders 1000s of buttons, create only when needed -->
                <!-- v-if="enable_duration_popup" -->
                <div @mouseover="onMouseoverQuickSetDuration">
                  <template v-if="quickSetDurationActive">
                    <duration-quick-settings
                      v-if="!active_task_timer"
                      :value="task_duration_remaining"
                      @save="onQuickSetDurationRemaining($event)"
                      :quickDurationSettings="{
                        '0 min': 0 * 60,
                        '1 min': 1 * 60,
                        '3 min': 3 * 60,
                        '5 min': 5 * 60,
                        '10 min': 10 * 60,
                        '15 min': 15 * 60,
                        '20 min': 20 * 60,
                        '25 min': 25 * 60,
                        '30 min': 30 * 60,
                        '45 min': 45 * 60,
                        '1 h': 1 * 60 * 60,
                        '2 h': 2 * 60 * 60,
                        '3 h': 3 * 60 * 60,
                        '4 h': 4 * 60 * 60,
                        '8 h': 8 * 60 * 60,
                      }"
                    >{{ task_duration_remaining | hoursMinutes }}</duration-quick-settings>
                    <TaskListItemDuration
                  v-else
                  :goalId="goalId"
                  :memberId="memberId"
                  :task="task"
                  :activeTask="activeTask"
                />
                  </template>
                  <template v-else>{{ task_duration_remaining | hoursMinutes }}</template>
                </div>
              </div>
              <div class="task-list-item-duration" v-if="finishDate && finishDate > 0">
                <!-- TODO: Avoid time conversions in templates, use e-moment instead! -->
                <font-awesome-icon
                  :icon="['fas', 'flag-checkered']"
                  style="margin-right: 0.3em"
                />
                {{(finishDate * 1000)|completionDateShort}}
                <!-- '> ' + optimizer_planning_horizon + ' days (Go Pro)' -->
              </div>
              <div v-if="task.reward">{{task.reward}}</div>
            </div>
            <div v-if="task.jobstopper" class="text-truncate" style="width: 200px">
              Jobstopper: <font-awesome-icon icon="hand-paper" style="margin-right: 0.3em"/>
              {{task.jobstopper}}
            </div>
          </div>
          <div style="flex: 0 0 20px" v-if="!hideAdditionalButtons">
            <div class="task-list_item__buttons">
              <div @mouseover="onMouseoverEllipsisButton" v-if="isEditable && !task.deleted">
                <!-- TODO: Move this logic to ellipsis button! -->
                <template v-if="ellipsisButtonActive">
                  <ellipsis-button
                    ref="ellipsisButton"
                    heading="Task Actions"
                    width="400"
                    :show-options="['slot']">

                    <el-row :gutter="10">
                      <el-col :span="12">

                        <el-button
                          v-if="taskIsUrl"
                          class="btn-block ml-0"
                          style="color: var(--blue)"
                          size="mini"
                          @click="onOpenURL">
                          <font-awesome-icon icon="external-link-alt"  />
                          Open URL in new window
                        </el-button>

                        <el-button class="btn-block ml-0" size="mini" @click="onGoToTaskPage(true)">
                          <font-awesome-icon :icon="['fas', 'link']" />
                          Open in new window
                        </el-button>

                        <el-button class="btn-block ml-0" size="mini" @click="onMoveTaskToTop">
                          <font-awesome-icon icon="arrow-up" />
                          Move to top
                        </el-button>

                        <el-button class="btn-block ml-0" size="mini" @click="onMoveTaskToGoal">
                          <font-awesome-icon icon="truck" />
                          Move to another goal
                        </el-button>

                        <el-button
                          class="btn-block ml-0"
                          size="mini"
                          @click.prevent="onDuplicateTask">
                          <font-awesome-icon icon="copy"  />
                          Duplicate
                        </el-button>

                        <el-button
                          class="btn-block ml-0"
                          size="mini"
                          @click.prevent="onRemoveTask( true )"
                          type="danger" >
                          <font-awesome-icon icon="archive"  />
                          Archive
                        </el-button>

                        <el-button
                          class="btn-block ml-0"
                          size="mini"
                          @click.prevent="onRemoveTask( false )"
                          type="danger" >
                          <font-awesome-icon icon="trash-alt"  />
                          Permanently delete
                        </el-button>

                      </el-col>
                      <el-col :span="12">

                        <el-button class="btn-block ml-0" size="mini" @click="onAddToDayplan(task)" :disabled="true">
                          <font-awesome-icon icon="calendar-alt" />
                          Add to dayplan
                        </el-button>

                        <el-button class="btn-block ml-0" size="mini" @click="onAssignTaskToUser(task)">
                          <font-awesome-icon icon="users" class="users"/>
                          Assign to user
                        </el-button>

                        <el-button
                          v-if="!active_task_timer"
                          class="btn-block ml-0"
                          size="mini"
                          @click="onStartTimer(task.durationRemaining)">
                          <font-awesome-icon :icon="['far', 'play-circle']" />
                          Start Timer
                        </el-button>
                        <el-button
                          v-if="active_task_timer"
                          class="btn-block ml-0"
                          size="mini"
                          @click="onStopTimer()">
                          <font-awesome-icon
                            v-if="timer_status === 'running'"
                            style="margin-right: 0.3em; cursor: pointer"
                            :icon="['far', 'stop-circle']"
                            />
                          Stop Timer
                        </el-button>

                        <color-selector
                          class="mt-2 mb-1"
                          headline="Set task label"
                          size="small"
                          :selected_color="task.label"
                          @color-select="onTaskSetLabel"/>

                        <emoji-selector
                          v-if="FEATURE_BUG_BOUNTY"
                          class="mt-2 mb-1"
                          headline="Bug bounty"
                          size="small"
                          :selected_emoji="task.reward"
                          @emoji-select="onTaskSetReward"/>

                        <!-- (Can be done on task page)
                        <template v-if="task.attachments">
                          <el-button
                            v-for="(attachment_url, attachment_id) in task.attachments"
                            :key="attachment_id"
                            class="btn-block ml-0"
                            size="mini"
                            type="danger"
                            @click="onDeleteAttachment(attachment_id)" >
                          <font-awesome-icon icon="trash-alt"/>Delete attachment:
                            <br>
                            // TODO: only if mime type image!
                            <img :src="attachment_url" width="32">
                          </el-button>
                        </template>
                        -->

                      </el-col>
                    </el-row>
                  </ellipsis-button>
                </template>
                <template v-else >
                  <el-button class="ellipsis-button__button">
                    <font-awesome-icon size="sm" :icon="['fas', 'ellipsis-v']" color="#687a8c"/>
                  </el-button>
                </template>
              </div>
            </div>
          </div>

          <!-- v-if="this.isActive"   -->
          <div style="position: absolute; top: 2px; right: 20px">
            <div v-if="!task.done && !task.deleted">
              <!--<el-button
                style="width: 45%"
                v-show="!active_task_timer"
                class="btn-block ml-0"
                size="mini"
                @click.prevent="onStartWorkOnTask()">
                <font-awesome-icon
                  :icon="['far', 'play-circle']"
                  v-tooltip="{ content: 'Start Timer'}"/>
                Start Timer
              </el-button>
              <el-button
                style="width: 45%"
                v-show="active_task_timer"
                class="btn-block ml-0"
                size="mini"
                @click.prevent="onStopTimer()">
                <font-awesome-icon
                  :icon="['far', 'stop-circle']"
                  v-tooltip="{ content: 'Stop Timer'}"/>
                Stop Timer
              </el-button>-->
              <!-- v-tooltip="{ content: 'Start working on task' }" -->
            </div>
            <!--<div v-else>
              <font-awesome-icon icon="archive" @click.prevent="onStartWorkOnTask(task.$id)" v-tooltip="{ content: 'See archived task' }" />
            </div>-->
            <div v-if="task.deleted">
              <font-awesome-icon
                icon="archive"
                @click.prevent="onRestoreTask"
                class="mr-1"
                v-tooltip="{ content: 'Restore task' }"
              />
            </div>
          </div>
        </div>

        <!-- WORKAROUND -->
        <div
          v-if="memberId !== laneAssignedUserId"
          style="text-align: center; font-size: 9pt; color: red; font-weight: 600; padding-top: 1em;">
          Task is out of sync.
          <a href="#" @click.prevent="onFixOutOfSyncTask">fix</a>.
        </div>

        <!--
      <p class="task-description">
        {{task.description}}
        <br />
        <span style="font-weight: bold" v-if="task.duration">Duration: {{task.duration|hoursAndMinutes}}</span>
      </p>
        -->
      </div>

      <div v-if="attachment_uploading" class="spinner-container">
        <i class="d-block el-icon-loading" style="font-size: 24pt"/>
      </div>

      <!--<div style="display: flex; flex-direction: column; justify-content: center" v-show="mouseoverActive">
        <div style="display: flex; flex-wrap: nowrap; justify-content: center">
          <el-button
            style="width: 45%"
            v-show="!active_task_timer"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onStartWorkOnTask()">
            <font-awesome-icon
              :icon="['far', 'play-circle']"
              v-tooltip="{ content: 'Start Timer'}"/>
            Start Timer
          </el-button>
          <el-button
            style="width: 45%"
            v-show="active_task_timer"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onStopTimer()">
            <font-awesome-icon
              :icon="['far', 'stop-circle']"
              v-tooltip="{ content: 'Stop Timer'}"/>
            Stop Timer
          </el-button>
          <el-button
            style="width: 45%"
            size="mini"
            @click.prevent="onMoveTaskToTop()">
            Move to Top
          </el-button>
        </div>
      </div>-->

      <!-- TODO -->
      <!--<span v-show="task.isDaily">
        <el-tooltip content="Daily task / Regular task">
          <font-awesome-icon icon="sync" class="symbol"/>
        </el-tooltip>
        {{task.dailyAtFixedTime}}
      </span>

      <span v-show="task.isTemplate">
        <el-tooltip effect="dark" content="Team template (needs to be checked by every lane member)">
          <font-awesome-icon icon="trophy" class="symbol"/>
        </el-tooltip>
      </span>-->
    </div>
    <div v-if="isDayplan && !hideAdditionalButtons" style="display: flex; justify-content: flex-end; align-items: flex-start; margin-left: 2px;">
      <div v-if="!taskInSession">
        <font-awesome-icon :icon="['fa', 'plus']" @click="onClickAddTaskToSession" class="inline-icon" />
      </div>
      <div v-if="taskInSession" @click="onClickRemoveTaskFromSession">
        <font-awesome-icon :icon="['fa', 'minus']" class="inline-icon" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "@/moment-gp.js";
import util from "@/util";
import TaskAttachmentMixin from "@/components/Mixins/TaskAttachment";
import TaskManagementMixin from "@/components/Mixins/TaskManagement";
import TaskListItemDuration from "@/components/GoalPage/Elements/TaskListItemDuration";
import DropTaskPrompt from '@/components/Mixins/Prompts/DropTaskPrompt'
import { FEATURE_BUG_BOUNTY } from "@/features";

export default {
  name: "TaskListItem",
  mixins: [TaskAttachmentMixin, TaskManagementMixin, DropTaskPrompt],
  props: {
    goalId: {
      required: true,
      type: String,
    },
    task: {
      type: Object,
    },
    isEditable: {
      default: true,
    },
    memberId: {
      required: true,
      type: String,
    },
    laneAssignedUserId: {},
    laneId: {
      required: true,
    },
    enableProportionalTaskHeights: {
      default: false,
    },
    htmlTitle: {},
    finishDate: {
      type: Number,
      default: 0,
    },
    activeTask: {
      type: Object,
    },
    durationInSession: {
      type: Number,
      default: 0,
    },
    timeInSessionFrom: {
      type: Number,
    },
    timeInSessionTo: {
      type: Number,
    },
    isDayplan: {
      type: Boolean,
    },
    sessionId: {
      type: String,
    },
    tasksInSession: {
      type: Array,
    },
    hideAdditionalButtons: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String
    }
  },
  data() {
    return {
      FEATURE_BUG_BOUNTY,
      isActive: false,
      // user_input_error: null, // TODO
      // user_input_invalid_list: [],
      active_drop_target: false,
      toggle_fullscreen: false,
      // mouseoverActive: false,
      editTitleActive: false,
      ellipsisButtonActive: false,
      quickSetDurationActive: false,
    };
  },
  created() {
    this.setAttachmentScope('last');
  },
  computed: {
    ...mapGetters("optimizer", ["optimizer_planning_horizon"]),
    ...mapGetters("session", [
      //'session_timer_taskId',
      //'session_user_timer',
      // "session_timer_status",
    ]),
    /*active_task_timer() {
      if (this.session_timer_taskId) {
        return (this.session_timer_taskId ===  this.task.$id && this.session_timer_status(this.task.$id) === 'running')
      } else {
        return false
      }
    },*/
    active_task_timer() {
      if (this.activeTask) {
        return this.activeTask.taskId === this.task.$id;
      } else {
        return false;
      }
    },
    task_duration_remaining: {
      get() {
        return this.task.durationRemaining;
      },
      set() {},
    },
    timer_status() {
      // return this.session_timer_status(this.task.$id)
      return false; // Re-Rendering the entire Kanban every second?
    },
    task_style() {
      if (this.enableProportionalTaskHeights) {
        let duration = this.task.durationRemaining / 60 || 15;
        let height = Math.min(Math.max(40, duration + 30), 240);
        return { "min-height": height + "px" };
      }
      return {};
    },
    task_meta() {
      return this.task;
    },

    finish_today() {
      return (
        this.finishDate >=
          moment
            .currentTime()
            .startOf("day")
            .unix() &&
        this.finishDate <=
          moment
            .currentTime()
            .endOf("day")
            .unix()
      );
    },
    taskInSession() {
      if (this.isDayplan && this.tasksInSession.filter(item => item.taskId === this.task.$id).length === 1) {
        return true;
      }
      return false;
    },
    taskIsUrl() {
      return util.isURL( this.task.name );
    },
  },
  methods: {
    /* onCheckTask     --> TaskManagement Mixin */
    /* onTaskSetLabel  --> TaskManagement Mixin */
    /* onTaskSetReward --> TaskManagement Mixin */
    /* onSetTaskName   --> TaskManagement Mixin */
    /* onRestoreTask   --> TaskManagement Mixin */
    /* onShowTaskModal --> TaskManagement Mixin */
    /* onDuplicateTask --> TaskManagement Mixin */
    /* onRemoveTask    --> TaskManagement Mixin */
    /* onAddToDayplan  --> TaskManagement Mixin */
    /* onAssignTaskToUser --> TaskManagement Mixin */

    onClickTask() {
      if (this.editTitleActive) {
        return
      }

      if ( !this.$router ) {
        /* HACK, when shown in a promp */
        return
      }

      this.onGoToTaskPage(false);
    },

    onGoToTaskPage(newWindow = false) {
      let route =
        "/goal/"   + this.goalId +
        "/member/" + this.memberId +
        "/task/"   + this.task.$id

      if ( newWindow ) {
        var win = window.open(window.location.origin + '/taskdetails' + route, '_blank');
        win.focus();
      } else {
        this.$router.push( ( this.isDayplan ? '/dayplanner' : '') + route);
      }
    },

    onOpenURL() {
      console.log("onOpenURL", this.task.name)
      var win = window.open(this.task.name, '_blank');
      win.focus();
    },

    /*onStartWorkOnTask(task_id) {

      this.onStartTimer(this.task.durationRemaining);
    },*/
    onMouseoverEllipsisButton() {
      this.ellipsisButtonActive = true;
    },

    onMouseoverQuickSetDuration() {
      this.quickSetDurationActive = true;
    },

    onFocusRenameTask() {
      this.editTitleActive = true;
      this.$nextTick(() => {
        if (this.$refs.name_title) {
          console.log("Focus on task", this.task.$id)
          this.$refs.name_title.focus();
        }
      });
    },

    onTitleLostFocus() {
      this.editTitleActive = false;
    },

    onQuickSetDurationRemaining(value) {
      this.$api.task_update({
        member_id: this.memberId,
        goal_id: this.goalId,
        task_id: this.task.$id,
        data: { durationRemaining: value },
      }).then( nothing => {
          if (this.task.$state.sessionId) {
            this.onAddTaskToSession({
              goalId: this.goalId,
              memberId: this.memberId,
              taskId: this.task.$id,
              tasksInSession: this.tasksInSession,
              sessionId: this.sessionId
            })
          }
        }
      )
    },

    onEnterEditMode() {
      this.$emit("focus", this.task.$id);
    },

    onFixOutOfSyncTask() {
      /* WORKAROUND */
      this.$api.task_assign_to_lane({
        old_member_id: this.memberId,
        new_member_id: this.laneAssignedUserId,
        goal_id: this.goalId,
        lane_id: this.laneId,
        task_id: this.task.$id,
      });
    },

    focus() {
      // TODO: This is not necessary anymore, browser deals with focus now
      /* called externally */
      // this.$refs.name_title.enterEditMode({ status: true });
      if (this.$refs.name_title) {
        this.$refs.name_title.focus();
      }
    },

    unfocus() {
      // TODO: This is not necessary anymore, browser deals with focus now
      /* called externally */
      // this.$refs.name_title.enterEditMode({ status: true });
      if (this.$refs.name_title) {
        this.$refs.name_title.blur();
      }
    },

    onDragOver(event) {
      // console.log(event.dataTransfer.dropEffect,
      //   event.dataTransfer.effectAllowed,
      //   event.buttons,
      //   event.returnValue,
      //   event.srcElement.classList);

      /* Workaround to detect if object being dragged is a file */
      // TODO: This needs more testing...
      if (event.dataTransfer.effectAllowed === "all") {
        this.active_drop_target = true;
      }

      /* Disable drag and drop events for sortable.js */
      if (this.active_drop_target) {
        event.preventDefault();
        event.stopPropagation();
      }
    },

    onDragLeave(event) {
      this.active_drop_target = false;
    },

    onMoveTaskToTop() {
      this.$refs.ellipsisButton.menu_visible = false;
      this.$emit("move-to-top");
    },

    // onMouseOver() {
    //   this.mouseoverActive = true;
    // },

    // onMouseLeave() {
    //   this.mouseoverActive = false;
    // },

    onClickAddTaskToSession() {
      this.onAddTaskToSession({
        goalId: this.goalId,
        memberId: this.memberId,
        taskId: this.task.$id,
        tasksInSession: this.tasksInSession,
        sessionId: this.sessionId
      })
    },

    onClickRemoveTaskFromSession() {
      this.onRemoveTaskFromSession({
        goalId: this.goalId,
        memberId: this.memberId,
        taskId: this.task.$id,
        tasksInSession: this.tasksInSession,
        sessionId: this.sessionId
      })
    },
  },
  filters: {
    hoursAndMinutes(minutes) {
      let duration = moment.duration(minutes, "minutes");
      return duration.humanize();
      // return util.showHoursMinutesSeconds( minutes * 60 * 1e3 );
    },
  },
  components: {
    TaskListItemDuration,
  },
};
</script>

<style>
.task-list-item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.task-description {
  font-size: 9pt;
  /* font-size: 10pt;
  background-color: #f5f5f5;
  padding: 3px 5px;
  margin: 0 40px 0 0; */
  padding: 0 0;
  margin: 0 50px 0 18px;
  display: block;
  line-height: 1em;
}
.task-list-item-infos {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.task-list-item-duration {
  margin-top: 0.03em;
  font-size: 9pt;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  font-style: normal;
  align-items: center;
  /* font-size: 10pt;
  background-color: #f5f5f5;
  padding: 3px 5px;
  margin: 0 40px 0 0; */
}
.task-list-item-duration > svg {
  color: #444444;
}
.task-description > span {
  font-size: 9pt;
  font-weight: bold;
  /* cursor: col-resize; */
  cursor: pointer;
}
.task-description > span:hover {
  text-decoration: underline;
}
.task-heading span:hover {
  border: 1px dashed gray;
  padding: 0;
  /* margin-top: -1px;
  margin-bottom: -1px;
  margin-left: calc(1em - 1px);
  margin-right: -1px; */
}
.task-heading svg {
  margin-top: 2px;
  height: 20px;
  float: left;
}
.task-heading span {
  /* display: inline; */
  cursor: text;
  line-height: 1.05em;
  /* NEU */
  padding: 1px;
  display: block;
  margin-left: 0.9em;
}
.task-list-item.sortable-ghost .task {
  background-color: transparent !important;
  border: 1px dashed black !important;
}
.dayplan-inner-container > .sortable-ghost {
  /* keep space below drag item in dayplan */
  margin-bottom: 30px;
}
.task-list-item.sortable-ghost .task > * {
  /* display: none !important; */
  opacity: 0 !important;
}
.sub-title {
  font-weight: bold;
  margin-top: 0.5em;
}
.task {
  flex-grow: 1;
  min-height: 30px;
  cursor: pointer;
  position: relative;
}
.task:hover {
  cursor: pointer;
}
.task:hover .attachment-icon {
  display: block;
}
.task .attachment-icon {
  display: none;
  height: 24px;
  width: 24px;
  margin-left: 0.5rem;
  cursor: pointer;
  padding: 3px;
  border-radius: 3px;
  color: black;
}
.task .attachment-icon:hover {
  background-color: #c6e2ff;
  color: #409EFF;
}
/*
.task-icons-active {
  display: inline;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;

  border: 1px solid #e0e0e0;
  background: #fdfdfd;
  border-radius: 5px;
  padding: 2px;
}
.task-icons-inactive {
  display: none;
}
*/
.task .fun-factor .el-radio-button__inner {
  font-size: 25pt;
}
.line-through {
  /* NAME IS TOO GENERIC -> MOVE TO APP?!!! */
  text-decoration: line-through;
}
.task .ellipsis-button__button {
  border: none;
  background: inherit;
  padding: 0 6px;
}
.task.file-drop-zone:hover {
  border: 3px dashed #9a9a9a !important;
}
.task.file-drop-zone {
  border: 3px dashed #eaeaea !important;
  border-radius: 3px;
  margin: -4px;
  padding: 2px;
}
.task.file-uploading > *,
.task.file-drop-zone > * {
  /* Hide icons when dropping file. Use opacity trick so height stays the same. */
  opacity: 0;
  /* Fix "blinking" issue */
  pointer-events: none;
}
.task .task-image > img {
  border: 1px solid #ffffff;
  border-radius: 3px;
}
.task-lane-item-text {
  line-height: 1.2;
  height: auto; /* TODO */
  /* min-height: 228px; */
  /* max-width: 205px; */
  margin-right: 1em;
  /*overflow: hidden;*/
  word-break: break-word;
}
.task-lane-item--time {
}
.task.is-deleted {
  background: repeating-linear-gradient(-45deg, #cd201f40, #cd201f40 5px, #50131240 5px, #50131240 10px);
}
.task .task__label {
  width: 8px;
  border-radius: 4px;
  margin-right: 5px;
}
.task.has-jobstopper {
  background: #f9d7d7 !important;
}
.task.timer-active {
  animation: pulse_border_kanban_task 3s infinite;
}
@keyframes pulse_border_kanban_task {
  0% {
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  50% {
    border: 1px solid #69b42d;
    background-color: rgba(105, 180, 45, 0.2);
  }
  100% {
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.task.finish-today {
  /*background-image: linear-gradient(to right,#B1D6E4 50%, #B1D6E4 100%);*/
}
.task .task__content {
  display: flex;
  align-items: stretch;
  position: relative;
}
.task .task__content .text-truncate {
  font-size: 9pt;
}
.task .task__checkbox {
  flex: 0 0 25px;
  padding-top: 1px;
  padding-left: 2px;
  align-self: start;
}
.task .task__checkbox:hover > svg {
  color: #5eba00 !important;
}
/* show edit button only on task hover */
.task .task-list-item__edit-button {
  display: none;
  color: black;
  margin: 0;
  margin-left: 8px;
  padding: 4px;
  height: 24px;
  width: 24px;
}
.task:hover .task-list-item__edit-button {
  display: inline-block;
  position: absolute;
}
.task--is-url .task-lane-item-text {
  color: var(--blue);
}
.task-list_item__buttons {
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  align-items: flex-start;
}
</style>
